import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Mega Pack después de comprar?',
  a: 'Recibirás el acceso al material de forma rápida para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.'
}, {
  q: '¿Para qué nivel educativo está pensado?',
  a: 'Para docentes universitarios, de terciarios, de posgrado y de cualquier nivel donde se enseñe metodología de la investigación.'
}, {
  q: '¿Sirve para cualquier país hispanohablante?',
  a: 'Sí. El material está redactado en español neutro y pensado para docentes de todo el mundo de habla hispana.'
}, {
  q: '¿El material es editable?',
  a: 'No. Todo el material viene en formato PDF listo para usar, proyectar o entregar a tus alumnos directamente.'
}, {
  q: '¿En qué moneda voy a pagar?',
  a: 'Pagarás en tu moneda local, de acuerdo con la pasarela de pago disponible en tu país. No necesitas tener dólares ni hacer conversiones manuales.'
}, {
  q: '¿Qué incluye la oferta especial de 27,90?',
  a: 'Incluye material complementario sobre las metodologías más importantes de la investigación según disciplinas: salud, ciencias naturales, ciencias sociales, educación, metodología cuantitativa, cualitativa, mixta y los diseños de investigación más utilizados. Todo listo para llevar al aula.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tienes 7 días de garantía para solicitar la devolución completa de tu dinero, sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-79" data-mp="wy5no0rjiucs">
      <div className="max-w-3xl mx-auto" data-id="element-80" data-mp="wyxkfewviy4n">
        <div className="text-center mb-16" data-id="element-81" data-mp="iyd02ebb8u91">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-82" data-mp="izfqkl4q0uof">
            ❓ Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-83" data-mp="n22liuwouvpu">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-84" data-mp="2pnexayivjdm7" data-mpi={index}>
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-85" data-mp="2fwtueyw63mxh">
                <span className="font-bold text-lg text-white pr-8" data-id="element-86" data-mp="38lrcb0wgvhpp">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-87" data-mp="33npqi87np4aj" />
              </button>

              <AnimatePresence data-id="element-88" data-mp="2ukybxzjhhseo">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-89" data-mp="1n8ervbu82x31">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-90" data-mp="cgyvcopvy8nb">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}